import axios from 'axios'
import { Message } from 'element-ui'
import store from '@/store'
import { getToken } from '@/utils/auth'
// import { randomString } from '@/utils/common'
// import md5 from 'js-md5'
// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // api的base_url
  timeout: 180 * 1000, // 请求超时时间
})

// request拦截器
service.interceptors.request.use(
  (config) => {
    if (localStorage.getItem('lang')) {
      config.headers['lang'] = localStorage.getItem('lang')
    } else {
      config.headers['lang'] = 'en_US'
    }
    if (store.getters.token)
      config.headers['Authorization'] = 'Bearer ' + getToken()
    config.headers['Cache-Control'] = 'no-cache'
    config.headers['Timezone'] =
      Intl.DateTimeFormat().resolvedOptions().timeZone

    return config
  },
  (error) => {
    // Do something with request error
    console.log(error) // for debug
    Promise.reject(error)
  }
)

// respone拦截器
service.interceptors.response.use(
  (response) => {
    /**
     * code为非20000是抛错 可结合自己业务进行修改
     */
    const res = response.data
    // console.log(res)
    if (res.code !== 0) {
      Message({
        message: res.msg,
        type: 'error',
        duration: 3 * 1000,
      })

      // 50008:非法的token; 50012:其他客户端登录了;  50014:Token 过期了;
      if (res.code === 401) {
        store.dispatch('FedLogOut').then(() => {
          location.reload()
        })
      }
      return Promise.reject('error')
    } else {
      return response.data
    }
  },
  (error) => {
    console.log(error) // for debug
    let msg = '网络出错了'
    if (error.response && error.response.data && error.response.data.msg) {
      msg = error.response.data.msg
    }
    Message({
      message: msg,
      type: 'error',
      duration: 5 * 1000,
    })
    store.dispatch('FedLogOut')
    return Promise.reject(error)
  }
)

export default service
